import { render, staticRenderFns } from "./datastore-main.vue?vue&type=template&id=40b82382&scoped=true&"
import script from "./datastore-main.vue?vue&type=script&lang=js&"
export * from "./datastore-main.vue?vue&type=script&lang=js&"
import style0 from "./datastore-main.vue?vue&type=style&index=0&id=40b82382&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b82382",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSheet,VSwitch,VTextField})
